import { escapeHtml } from '../utils/html.js';
import { renderAvatarInner } from '../utils/avatar.js';
import { formatMatchLabel } from '../utils/competitions.js';
import { EMOJI_MAP } from '../utils/reactions.js';
import { debriefVisibilityOption, DEBRIEF_VISIBILITY } from '../utils/visibility.js';
import { currentLocale, tr } from '../services/i18n.js';

export function renderDebriefCard(debrief) {
  const title   = debrief.title || tr('Analyse sans titre', 'Untitled analysis');
  const summary = debrief.summary || tr('Aucun résumé disponible.', 'No summary available.');
  const moment  = debrief.key_moment || tr('Moment clé à préciser', 'Key moment to clarify');
  const author  = debrief.user || { pseudo: tr('Anonyme', 'Anonymous'), avatar_url: '' };
  const counts  = debrief.reaction_counts || {};
  const visibility = debriefVisibilityOption(debrief.visibility);
  const created = new Date(debrief.created_at).toLocaleDateString(currentLocale(), { day: 'numeric', month: 'short', year: 'numeric' });
  const context = debrief.match
    ? formatMatchLabel(debrief.match)
    : debrief.competition?.name || '';

  const card = document.createElement('article');
  card.className = 'glass-card';
  card.style.cssText = 'cursor:pointer; padding:20px; border-radius:var(--radius-lg);';

  card.innerHTML = `
    <!-- Header -->
    <div style="display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:14px;">
      <div style="display:flex; align-items:center; gap:10px; min-width:0;">
        <div class="avatar" style="width:34px; height:34px; font-size:15px;">
          ${renderAvatarInner(author, { imgStyle: '' })}
        </div>
        <div style="min-width:0;">
          <p style="font-family:var(--font-ui); font-weight:700; font-size:13px; margin:0; color:var(--ink); overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">@${escapeHtml(author.pseudo || tr('anonyme', 'anonymous'))}</p>
          <p style="font-size:11px; margin:0; color:var(--muted);">${escapeHtml(created)}</p>
        </div>
      </div>
      <div style="display:flex;align-items:center;gap:6px;min-width:0;flex-wrap:wrap;justify-content:flex-end;">
        ${debrief.visibility && debrief.visibility !== DEBRIEF_VISIBILITY.PUBLIC ? `
          <span style="font-family:var(--font-ui); font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:var(--gold); background:rgba(218,165,32,0.1); border:1px solid rgba(218,165,32,0.25); padding:3px 9px; border-radius:999px; white-space:nowrap;">
            ${escapeHtml(visibility.badge)}
          </span>` : ''}
        ${context ? `
          <span style="font-family:var(--font-ui); font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:var(--primary-h); background:rgba(26,122,74,0.1); border:1px solid rgba(26,122,74,0.2); padding:3px 9px; border-radius:999px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:130px;">
            ${escapeHtml(context)}
          </span>` : ''}
      </div>
    </div>

    <!-- Contenu -->
    <h3 style="font-family:var(--font-ui); font-size:17px; font-weight:800; margin:0 0 8px; line-height:1.25; color:var(--ink); letter-spacing:-0.02em;">${escapeHtml(title)}</h3>
    <p style="margin:0 0 14px; font-size:13px; color:var(--ink-2); display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; line-height:1.55;">${escapeHtml(summary)}</p>

    <!-- Instant Clé -->
    <div style="margin-bottom:14px; padding:10px 14px; border-radius:var(--radius-md); background:var(--surface-2); border:1px solid var(--glass-border); border-left:3px solid var(--gold);">
      <span style="display:block; font-family:var(--font-ui); font-size:9px; font-weight:700; text-transform:uppercase; letter-spacing:0.1em; color:var(--gold); margin-bottom:3px;">${tr('Instant Clé', 'Key Moment')}</span>
      <p style="margin:0; font-size:13px; color:var(--ink); font-weight:600; line-height:1.4;">${escapeHtml(moment)}</p>
    </div>

    <!-- Réactions -->
    <div style="display:flex; gap:6px; flex-wrap:wrap; pointer-events:none;">
      <span class="reaction-btn" style="font-size:12px;">${EMOJI_MAP.fire} <small style="font-weight:700; margin-left:3px;">${Number(counts.fire) || 0}</small></span>
      <span class="reaction-btn" style="font-size:12px;">${EMOJI_MAP.brain} <small style="font-weight:700; margin-left:3px;">${Number(counts.brain) || 0}</small></span>
      <span class="reaction-btn" style="font-size:12px;">${EMOJI_MAP.cap} <small style="font-weight:700; margin-left:3px;">${Number(counts.cap) || 0}</small></span>
    </div>
  `;

  card.addEventListener('click', () => {
    window.location.hash = `#/debrief/${debrief.id}`;
  });

  return card;
}
